import useModal from 'hooks/useModal';
import type { Connector } from 'types/transactions.types';
import { WalletTopUpBankAccount } from './WalletTopUpBankAccount.component';

const useWalletTopUpBankAccount = () => {
  const [modalContent, modalApi] = useModal({
    width: '2xl',
    name: 'Wallet top up bank account modal',
    color: 'bank',
  });

  const openWalletTopUpBankAccountModal = (connector?: Connector) => {
    modalApi.open(() => <WalletTopUpBankAccount connector={connector} />);
  };

  return {
    walletTopUpBankAccountContent: modalContent,
    openWalletTopUpBankAccountModal,
  };
};

export default useWalletTopUpBankAccount;
